import store from "@/store";

export const mixinTicket = {
  data: () => ({
  }),
  computed: {
  },
  methods: {
    async getTicketList() {  // 유저 티켓 리스트 API
      await store.dispatch('getTicketList')
          .then(res => {
            if (res.success) {
              this.ticketList = res.data
              store.commit('initTicketList', res.data)
            } else {
              console.log(res.msg)
            }
          })
          .catch(error => {
            console.error(error)
          })
          .finally(() => {

          })
    },
    async getFireTicketList() {  // 유저 삼성 티켓 리스트 API
      await store.dispatch('getFireTicketList')
        .then(res => {
          if (res.success) {
            this.ticketList = res.data
            store.commit('initTicketList', res.data)
          } else {
            console.log(res.msg)
          }
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
        })
    }
  }
}

